/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Supervisory_TitleInputs */

const en_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Supervisory Authority`)
};

const de_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Aufsichtsbehoerde`)
};

const fr_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Autorité de contrôle`)
};

const es_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Autoridad de control`)
};

const it_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Autorità di controllo`)
};

const nl_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Toezichthoudende autoriteit`)
};

const pl_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Organ nadzorczy`)
};

const fi_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Valvontaviranomainen`)
};

const da_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Tilsynsmyndighed`)
};

const sv_privacy_supervisory_title = /** @type {(inputs: Privacy_Supervisory_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Tillsynsmyndighet`)
};

/**
* | output |
* | --- |
* | "7. Supervisory Authority" |
*
* @param {Privacy_Supervisory_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_supervisory_title = /** @type {((inputs?: Privacy_Supervisory_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Supervisory_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_supervisory_title(inputs)
	if (locale === "fr") return fr_privacy_supervisory_title(inputs)
	if (locale === "es") return es_privacy_supervisory_title(inputs)
	if (locale === "it") return it_privacy_supervisory_title(inputs)
	if (locale === "nl") return nl_privacy_supervisory_title(inputs)
	if (locale === "pl") return pl_privacy_supervisory_title(inputs)
	if (locale === "fi") return fi_privacy_supervisory_title(inputs)
	if (locale === "da") return da_privacy_supervisory_title(inputs)
	if (locale === "sv") return sv_privacy_supervisory_title(inputs)
	return en_privacy_supervisory_title(inputs)
});